export default __webpack_public_path__ + "static/media/selector.006f1970.svg";